import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export async function patchBalance(data) {
  const finres = await axios.patch('users/update', data);
  return finres;
}

export const addBalance = createAsyncThunk('users/update', async balance => {
  const data = await patchBalance(balance);
  return data;
});
